const retailMultitable = require('./retail-fullcont-multitable')
const ENTER_AUTOCOMPLETE_DELAY_MS = 50

export function add_line_item(detail) {
      const isEnter = detail.ev.type === 'keyup'
            && (detail.ev.key === 'Enter' || detail.ev.keyCode === 13)
      const isTabOnTotal = detail.ev.type === 'keydown'
            && (detail.ev.key === 'Tab' || detail.ev.keyCode === 9)
            && detail.ev.target.closest('.total') !== null

      if (!isEnter && !isTabOnTotal) { return }

      const multitable = document.getElementById('retail_form_sale_vs_item')
      const lines = multitable.querySelectorAll('.line')
      const lastLine = lines[lines.length - 1]

      if (lastLine && lastLine.contains(detail.ev.target)) {
            detail.ev.preventDefault()
            retailMultitable.start({ act: 'add', tableName: 'sale_vs_item', tab: true })

            if (isEnter) {
                  setTimeout(() => focusLastItemAutocomplete(multitable), ENTER_AUTOCOMPLETE_DELAY_MS)
            }
      }
}

function focusLastItemAutocomplete(multitable) {
      const lines = multitable.querySelectorAll('.line')
      const lastLine = lines[lines.length - 1]
      const itemInput = lastLine?.querySelector('.purchase_vs_itemId input')

      if (!itemInput) { return }

      itemInput.focus()
      itemInput.click()
}
